var map = {
	"./bg-BG.json": 2296,
	"./ca-ES.json": 2297,
	"./cs-CZ.json": 2298,
	"./de-DE.json": 2299,
	"./el-GR.json": 2300,
	"./en-US.json": 1166,
	"./es-ES.json": 2301,
	"./et-EE.json": 2302,
	"./fi-FI.json": 2303,
	"./fr-FR.json": 2304,
	"./he-IL.json": 2305,
	"./it-IT.json": 2306,
	"./ja-JP.json": 2307,
	"./ko-KR.json": 2308,
	"./nb-NO.json": 2309,
	"./nl-NL.json": 2310,
	"./nn-NO.json": 2311,
	"./pl-PL.json": 2312,
	"./pt-BR.json": 2313,
	"./ro-RO.json": 2314,
	"./ru-RU.json": 2315,
	"./sk-SK.json": 2316,
	"./sv-SE.json": 2317,
	"./tr-TR.json": 2318,
	"./zh-CN.json": 2319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2295;